/* eslint-disable @typescript-eslint/no-explicit-any */
import { Calendar } from "alurkerja-ui";
import { useState } from "react";

export default function DateFilterComponent({
  name,
  handleChangeFilterByColumns,
  type = "range",
}: {
  name: string;
  handleChangeFilterByColumns: (key: string, value: any) => void;
  type?: any;
}) {
  const [maxDate, setMaxDate] = useState(new Date());
  const [minDate, setMinDate] = useState<Date | undefined>(undefined);

  return (
    <Calendar
      placeholder="Filter Date"
      inputClassName="bg-slate-100 h-8 border-0"
      defaultValue={undefined}
      onApply={(value) => {
        handleChangeFilterByColumns(name, value);
      }}
      onChange={(value) => {
        if (value.date_start && !value.date_end) {
          const dateMax = new Date(value.date_start);
          dateMax.setMonth(dateMax.getMonth() + 3);
          setMaxDate(dateMax);
        }

        if (value.date_start) {
          const dateMin = new Date(value.date_start);
          dateMin.setMonth(dateMin.getMonth() - 3);
          setMinDate(dateMin);
        }
      }}
      maxDate={maxDate}
      minDate={minDate}
      type={type}
    />
  );
}
